export default "__VITE_ASSET__CU1RBRu0__"